<template>
  <section class="agreement-created-container">
    <h1>!ההסכמים הופקו בהצלחה</h1>
    <img class="slide-in-elliptic-top-fwd" src="https://cdn3.iconfinder.com/data/icons/flat-actions-icons-9/792/Tick_Mark_Dark-512.png" alt="">
<h5>.מיד תועבר לעמוד הורדת המסמך</h5>

    <a :href="agreementLink" target="_blank">.לחץ כאן להורדת המסמך</a>
    <div>
 <button @click="createAnotherAgreement" class="mr-5 btn btn-success">  צור מסמך חדש <i class="fas fa-folder-plus"></i></button>
 <button @click="sendViaWhatsapp()"  class="mr-5 btn btn-success">   שלח קישור למסמך בוואטסאפ  <i class="fab fa-whatsapp"></i>
 </button>
 <button @click="copyLinkToClipboard" class="mr-5 btn btn-success">  העתק קישור למסמך <i class="fas fa-copy"></i></button>
    </div>
  </section>
</template>

<script>
export default {
  name: "agreement-created",
  props:["agreementLink","ownerPhone"],
  data(){
    return{
      isShown:false
    }
  },
  methods:{
    createAnotherAgreement(){
      this.$emit("createAnotherAgreement")
    },
    copyLinkToClipboard(){
      const el = document.createElement('textarea');
      el.value = this.agreementLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert("הקישור העותק!")
    },
    sendViaWhatsapp(){
      let num = `+972${this.ownerPhone}`;
      let msg=`
      היי, שולח לך קישור לטופס הדיגיטלי שהרגע יצרתי!
      ${this.agreementLink}`
       window.open(`https://wa.me/${num}?text=${msg}`, "_blank");
    }
  },
};
</script>

<style scoped>
.agreement-created-container{
  font-family: Tahoma;
  margin: 50px auto;
  text-align: center;
}
.slide-in-elliptic-top-fwd{-webkit-animation:slide-in-elliptic-top-fwd 1s cubic-bezier(.25,.46,.45,.94) both;animation:slide-in-elliptic-top-fwd 1s cubic-bezier(.25,.46,.45,.94) both}
@-webkit-keyframes slide-in-elliptic-top-fwd{0%{-webkit-transform:translateY(-600px) rotateX(-30deg) scale(0);transform:translateY(-600px) rotateX(-30deg) scale(0);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}100%{-webkit-transform:translateY(0) rotateX(0) scale(1);transform:translateY(0) rotateX(0) scale(1);-webkit-transform-origin:50% 1400px;transform-origin:50% 1400px;opacity:1}}@keyframes slide-in-elliptic-top-fwd{0%{-webkit-transform:translateY(-600px) rotateX(-30deg) scale(0);transform:translateY(-600px) rotateX(-30deg) scale(0);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;opacity:0}100%{-webkit-transform:translateY(0) rotateX(0) scale(1);transform:translateY(0) rotateX(0) scale(1);-webkit-transform-origin:50% 1400px;transform-origin:50% 1400px;opacity:1}}
img{
  width: 200px;
}
.btn{
  margin-top: 15px;
}
.mr-5{
  margin-right: 5px;
}
</style>